import React, { Component } from "react";
import axios from "axios";
import { v4 as uuid } from "uuid";
import NotificationPack from "./NotificationPack";

const config = require("../config.json");

export default class NotificationPackAdmin extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    newNotificationPack: {
      id: uuid(),
      schedule: {},
      packName: "",
      amountPerDay: 0,
      amountOfDays: 0,
      amountOfDaysBeforeLeagueStart: 0,
      skipWeekends: false,
      times: [],
    },
    notificationPacks: [],
    notifications: [],
    loading: false,
  };

  handleAddNotificationPack = async (notificationPack, event) => {
    event.preventDefault();
    try {
      const params = {
        id: notificationPack.id,
        schedule: notificationPack.schedule,
        packName: notificationPack.packName,
        amountPerDay: notificationPack.amountPerDay,
        amountOfDays: notificationPack.amountOfDays,
        amountOfDaysBeforeLeagueStart:
          notificationPack.amountOfDaysBeforeLeagueStart,
        skipWeekends: notificationPack.skipWeekends,
        times: notificationPack.times,
      };

      await axios.post(
        `${config.api.invokeUrl}/notification/packs/${notificationPack.id}`,
        params
      );
      this.setState({
        notificationPacks: [
          ...this.state.notificationPacks,
          this.state.newNotificationPack,
        ],
        selectedNotifications: [],
      });
      this.setState({
        newNotificationPack: {
          id: uuid(),
          schedule: {},
          packName: "",
          amountPerDay: 0,
          amountOfDays: 0,
          amountOfDaysBeforeLeagueStart: 0,
          skipWeekends: false,
          times: [],
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleUpdateNotificationPack = async (notificationPack, notifications) => {
    notificationPack.notifications = notifications.map(
      (notification) => notification.id
    );
    try {
      const params = {
        id: notificationPack.id,
        notifications: notificationPack.notifications,
        packName: notificationPack.packName,
        packTitle: notificationPack.packTitle,
        packDescription: notificationPack.packDescription,
        packTitle_en: notificationPack.packTitle_en,
        packDescription_en: notificationPack.packDescription_en,
      };
      await axios.patch(
        `${config.api.invokeUrl}/notification/packs/${notificationPack.id}`,
        params
      );
    } catch (err) {
      console.log(err);
    }

    const updatedNotificationPacks = [...this.state.notificationPacks].filter(
      (c) => c.id !== notificationPack.id
    );
    updatedNotificationPacks.push(notificationPack);
    this.setState({ notificationPacks: updatedNotificationPacks });
  };

  handleDeleteNotificationPack = async (id, event) => {
    event.preventDefault();
    if (window.confirm(" Er du sikker?")) {
      try {
        await axios.delete(`${config.api.invokeUrl}/notification/packs/${id}`);
      } catch (err) {
        console.log(err);
      }
      const updatedNotificationPacks = [...this.state.notificationPacks].filter(
        (notificationPack) => notificationPack.id !== id
      );
      this.setState({ notificationPacks: updatedNotificationPacks });
    }
  };

  fetchNotificationPacks = async () => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/notification/packs/`
      );
      const notificationPacks = res.data;
      this.setState({ notificationPacks: notificationPacks });
    } catch (err) {
      console.log(err);
    }
  };

  fetchNotifications = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/notification`);
      const notifications = res.data;
      this.setState({ notifications: notifications });
    } catch (err) {
      console.log(err);
    }
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      newNotificationPack: {
        ...this.state.newNotificationPack,
        [name]: value,
      },
    });
  }

  handleTimeChange(event, index) {
    const newTimes = [...this.state.newNotificationPack.times];

    newTimes[index] = event.target.value;

    this.setState({
      newNotificationPack: {
        ...this.state.newNotificationPack,
        times: newTimes,
      },
    });
  }

  handleNotificationChange(day, time, notificationId) {
    this.setState({
      newNotificationPack: {
        ...this.state.newNotificationPack,
        schedule: {
          ...this.state.newNotificationPack.schedule,
          [this.state.newNotificationPack.times[time - 1]]: {
            ...this.state.newNotificationPack.schedule[
              [this.state.newNotificationPack.times[time - 1]]
            ],
            [day]: notificationId,
          },
        },
      },
    });
  }

  componentDidMount = () => {
    this.fetchAll();
  };

  fetchAll = async () => {
    this.setState({ loading: true });
    let promise = await Promise.all([
      this.fetchNotifications(),
      this.fetchNotificationPacks(),
    ]);
    this.setState({ loading: false });
  };

  render() {
    return !this.state.loading ? (
      <>
        <p className="subtitle is-5">Tilføj og fjern Notifikationspakker</p>
        <br />
        <div className="columns is-multiline is-flex-direction-column">
          <div className="column is-full">
            <form
              onSubmit={(event) =>
                this.handleAddNotificationPack(
                  this.state.newNotificationPack,
                  event
                )
              }
            >
              <div className="control">
                <input
                  className="input is-medium"
                  type="text"
                  name="packName"
                  placeholder="Indtast navn"
                  required
                  value={this.state.newNotificationPack.packName}
                  onChange={this.handleInputChange}
                />
                <div
                  className="column is-flex is-flex-direction-column "
                  style={{ maxWidth: 400 }}
                >
                  Antal dage
                  <input
                    type={"number"}
                    name={"amountOfDays"}
                    onChange={this.handleInputChange}
                    value={this.state.newNotificationPack.amountOfDays}
                  />
                  Antal notifikationer om dagen
                  <input
                    type={"number"}
                    name={"amountPerDay"}
                    onChange={this.handleInputChange}
                    value={this.state.newNotificationPack.amountPerDay}
                  />
                  Antal dage med notifikationer op til ligastart
                  <input
                    type={"number"}
                    name={"amountOfDaysBeforeLeagueStart"}
                    onChange={this.handleInputChange}
                    value={
                      this.state.newNotificationPack
                        .amountOfDaysBeforeLeagueStart
                    }
                  />
                  <div className="control">
                    <input
                      className="is-medium"
                      type={"checkbox"}
                      name={"skipWeekends"}
                      id="skipWeekends"
                      onChange={this.handleInputChange}
                      value={this.state.newNotificationPack.skipWeekends}
                    />
                    <label htmlFor="skipWeekends" style={{ marginLeft: 5 }}>
                      Spring system notifikationer over i weekenden
                    </label>
                  </div>
                  {Array.from(
                    {
                      length: parseInt(
                        this.state.newNotificationPack.amountPerDay
                      ),
                    },
                    (_, index) => index
                  ).map((index) => {
                    return (
                      <div key={index}>
                        <div>Afsendelsestid {index + 1} </div>
                        <input
                          type="time"
                          id={`${index + 1}time`}
                          onChange={(e) => {
                            this.handleTimeChange(e, index);
                          }}
                        />
                      </div>
                    );
                  })}
                  {Array.from(
                    {
                      length: parseInt(
                        this.state.newNotificationPack.amountOfDays
                      ),
                    },
                    (_, index) => index + 1
                  ).map((day) => {
                    const daysBefore = parseInt(
                      this.state.newNotificationPack
                        .amountOfDaysBeforeLeagueStart
                    );

                    return (
                      <div key={`notificans${day}`}>
                        {daysBefore > 0
                          ? day - 1 < daysBefore
                            ? `${daysBefore - (day - 1)} dage før`
                            : `Dag ${day - daysBefore}`
                          : "Dag " + day}

                        {Array.from(
                          {
                            length: parseInt(
                              this.state.newNotificationPack.amountPerDay
                            ),
                          },
                          (_, index) => index + 1
                        ).map((time) => {
                          return (
                            <div key={`notificans${day}${time}`}>
                              {this.state.newNotificationPack.times[0]
                                ? this.state.newNotificationPack.times[time - 1]
                                : "Tidspunkt " + time}
                              <select
                                style={{ marginLeft: 10 }}
                                className="select"
                                onChange={(e) => {
                                  console.log(
                                    "changing notfication for " + day + time
                                  );
                                  const select = e.target;
                                  const notificationId =
                                    select.options[select.selectedIndex].value;
                                  this.handleNotificationChange(
                                    day,
                                    time,
                                    notificationId
                                  );
                                }}
                                defaultValue={"system"}
                              >
                                <option id={"system"} value="">
                                  System
                                </option>
                                {this.state.notifications.map((notif) => {
                                  return (
                                    <option
                                      key={notif.id + day}
                                      value={notif.id}
                                    >
                                      {notif.notificationName}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
                <button type="submit" className="button is-primary is-medium">
                  Tilføj
                </button>
              </div>
            </form>
          </div>
          <div className="column">
            <div className="tile is-ancestor ">
              <div className="tile is-parent flex-wrap">
                {this.state.notificationPacks.map((notificationPack) => (
                  <NotificationPack
                    handleUpdateNotificationPack={
                      this.handleUpdateNotificationPack
                    }
                    handleDeleteNotificationPack={
                      this.handleDeleteNotificationPack
                    }
                    notificationPack={notificationPack}
                    notifications={this.state.notifications}
                    key={notificationPack.id}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </>
    ) : (
      <></>
    );
  }
}
